import { ReactElement, ReactNode } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import Modal from 'src/components/modal-dialog-actions';

import { messages } from './remove-access.i18n';

export type RemoveAccessModalProps = {
  onClose: () => void;
  onRemove: () => void;
  isLoading?: boolean;
  removeMessage: ReactElement<typeof FormattedMessage>;
  heading?: ReactNode;
};

const RemoveAccessModal = ({
  onClose,
  onRemove,
  isLoading,
  removeMessage,
  heading,
}: RemoveAccessModalProps) => {
  const { formatMessage } = useIntl();

  const actions = [
    {
      text: formatMessage(messages.cancel),
      onClick: onClose,
      appearance: 'subtle',
    },
    {
      text: formatMessage(messages.remove),
      onClick: onRemove,
      appearance: 'warning',
      autoFocus: true,
      isLoading,
      testId: 'remove-access-modal--remove-btn',
    },
  ];

  return (
    <Modal
      actions={actions as any}
      heading={heading || formatMessage(messages.removeAccessHeader)}
      width="small"
      onClose={onClose}
      appearance="warning"
    >
      {removeMessage}
    </Modal>
  );
};

// eslint-disable-next-line import/no-default-export
export default RemoveAccessModal;
